const layout = [
  'Q#############E',
  'L0000000000000R',
  'L0000000000000R',
  'L0000000000000R',
  'L0000012300000R',
  'L0000045600000R',
  'L0000078900000R',
  'L0000000000000R',
  'L0000000000000R',
  'L0000000000000R',
  'TBBBBBBBBBBBBBY',
];

export const main = layout.join('\n');
